module.exports = __webpack_public_path__ + "img/WechatIMG29796.84462c37.jpg";